import axios from "axios";
import { UploadTask } from "../../../domain/uploadtask/uploadtask";
import { Configuration, UploadTasksApi, UploadTaskUploadTaskResponse, UploadTaskYear } from "../generated";

export class UploadTasksRepository {
    private service: UploadTasksApi;

    constructor() {
        this.service = new UploadTasksApi(new Configuration(), process.env.REACT_APP_BACKEND_URL)
    }

    async ReadUploadTasks(): Promise<UploadTask[] | Error> {
        try {
            let response = await this.service.apiUploadTaskGet({ headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                let uploadtasks : UploadTask[] = []
                response.data?.map((uploadtaskApi) => {
                    let uploadtask = this.toDomainUploadTask(uploadtaskApi);
                    uploadtasks.push(uploadtask)
                })
                return uploadtasks
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async ReadDirsTreeOfSite(id: UniqueId): Promise<UploadTaskYear[] | Error> {
        try {
            let response = await this.service.apiUploadTaskIdTreeGet(id, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return response.data
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async ReadMonthsImagesOfSite(id: UniqueId, year: number, month: number): Promise<string[] | Error> {
        try {
            let response = await this.service.apiUploadTaskIdTreeYearMonthGet(id, year.toString(), month.toString(), { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return response.data
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    /*async ReadImageFromUrl(url: string): Promise<File | Error> {
        try {
            let response = await this.service.apiUploadTaskIdImageYearMonthFilenamePost({url:url}, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return response.data!
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }*/

    async CreateUploadTask(siteId: string,month: number,year: number,tmpFolder: string,imageOrder: string[]): Promise<UploadTask | Error> {
        try {
            let response = await this.service.apiUploadTaskPost({ site_id: siteId,month: month,year: year,tmp_folder: tmpFolder,image_order: imageOrder, }, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 201) {
                let uploadtask = this.toDomainUploadTask(response.data);
                return uploadtask
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async UpdateUploadTask(id: string,siteId: string,month: number,year: number,tmpFolder: string,imageOrder: string[]): Promise<UploadTask | Error> {
        try {

            let response = await this.service.apiUploadTaskIdPut(id, { site_id: siteId,month: month,year: year,tmp_folder: tmpFolder,image_order: imageOrder, }, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 201) {
                let uploadtask = this.toDomainUploadTask(response.data);
                return uploadtask
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async ReadUploadTaskById(id: UniqueId): Promise<UploadTask | Error> {
        try {

            let response = await this.service.apiUploadTaskIdGet(id, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                let uploadtask = this.toDomainUploadTask(response.data);
                return uploadtask
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async DeleteUploadTaskById(id: UniqueId): Promise<string | Error> {
        try {

            let response = await this.service.apiUploadTaskIdDelete(id, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return id
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }
    

    toDomainUploadTask(uploadtask: UploadTaskUploadTaskResponse): UploadTask {
        return new UploadTask( uploadtask.id!, uploadtask.site_id!, uploadtask.month!, uploadtask.year!, uploadtask.tmp_folder!, uploadtask.image_order!, uploadtask.upload_status!, new Date(uploadtask.created_at!), new Date(uploadtask.modified_at!), );
    }
    
}